export default {
  init() {
    $('[wc-action="add-to-cart"]').on('click', function() {
      const button = $(this);
      $(button)
        .find('.not-loading')
        .toggleClass('opacity-0');
      $(button)
        .find('.loading')
        .toggleClass('hidden');
      $(button).attr('disabled', 'disabled');
      $('#error-wrapper, #success-wrapper').hide();
      const product_id = $(this).attr('data-product-id');
      const data = {
        action: 'woocommerce_ajax_add_to_cart',
        product_id: product_id,
        product_sku: '',
        quantity: 1,
      };

      $(document.body).trigger('adding_to_cart', [data]);

      $.ajax({
        type: 'POST',
        url: wc_add_to_cart_params.ajax_url,
        data,
        success: function(response) {
          if (response.error) {
            $('#error-wrapper').fadeIn();
          } else {
            $(document.body).trigger('added_to_cart', [
              response.fragments,
              response.cart_hash,
            ]);
            $('#success-wrapper').fadeIn();
          }
          $(button).removeAttr('disabled');
          $(button)
            .find('.loading')
            .toggleClass('hidden');
          $(button)
            .find('.not-loading')
            .toggleClass('opacity-0');
        },
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js